// extracted by mini-css-extract-plugin
export default {"btnColor":"FormColors_btnColor__K47DV","listColors":"FormColors_listColors__M5iLb","colorItem":"FormColors_colorItem__zNJkv","checked":"FormColors_checked__eewwc"};